__turbopack_context__.v({
  "card": "SingleHighlightedArticleCard-module-scss-module__HHyHfW__card",
  "content": "SingleHighlightedArticleCard-module-scss-module__HHyHfW__content",
  "favoriteButton": "SingleHighlightedArticleCard-module-scss-module__HHyHfW__favoriteButton",
  "gradient": "SingleHighlightedArticleCard-module-scss-module__HHyHfW__gradient",
  "image": "SingleHighlightedArticleCard-module-scss-module__HHyHfW__image",
  "imageLink": "SingleHighlightedArticleCard-module-scss-module__HHyHfW__imageLink",
  "singleHighlightedArticleCard": "SingleHighlightedArticleCard-module-scss-module__HHyHfW__singleHighlightedArticleCard",
  "tags": "SingleHighlightedArticleCard-module-scss-module__HHyHfW__tags",
  "title": "SingleHighlightedArticleCard-module-scss-module__HHyHfW__title",
});
